import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-light ps-5 mt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventCard = _resolveComponent("EventCard")!
  const _component_Gallery = _resolveComponent("Gallery")!

  return (_ctx.eventGroup.events.length > 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t( 'category.' + _ctx.getCategorySlug( _ctx.eventGroup.category ) )), 1),
        _createVNode(_component_Gallery, {
          "single-line": _ctx.singleLine,
          id: 'eventContainer' + _ctx.getCategoryId(_ctx.eventGroup.category) ,
          "gallery-class": "ps-5 my-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventGroup.events, (event) => {
              return (_openBlock(), _createBlock(_component_EventCard, {
                key: event.id,
                event: event,
                class: "mx-1 cursor-pointer d-inline-block",
                onClick: ($event: any) => (_ctx.selectEvent(event)),
                "data-bs-toggle": "modal",
                "data-bs-target": "#homeEventDetailModal"
              }, null, 8, ["event", "onClick"]))
            }), 128)),
            _createElementVNode("div", {
              class: _normalizeClass(["event-card-more overflow-hidden text-light mx-1 text-center d-inline-block", _ctx.eventGroup.events.length > _ctx.eventGroup.page.size ? 'cursor-pointer' : 'shadow-none']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchForAnyCategory(_ctx.eventGroup.events.length > _ctx.eventGroup.page.size, _ctx.eventGroup.category)))
            }, [
              (_ctx.eventGroup.events.length > _ctx.eventGroup.page.size)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t( 'category.showAll', { count : _ctx.eventGroup.page.totalResults } )) + " ", 1),
                    _hoisted_2
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["single-line", "id"])
      ], 64))
    : _createCommentVNode("", true)
}